import { appConstants } from "../constants/appConstants"

function setUser(user: any) {
  function loadData(data: any) {
    return { type: appConstants.USER, data }
  }
  return (dispatch: any) => {
    dispatch(loadData(user))
  }
}

function setUserRole(userRole: any) {
  function loadData(data: any) {
    return { type: appConstants.USER_ROLE, data }
  }
  return (dispatch: any) => {
    dispatch(loadData(userRole))
  }
}
function setUserCurrentCenter(currentCenter: any) {
  function loadData(data: any) {
    return { type: appConstants.CURRENT_CENTER, data }
  }
  return (dispatch: any) => {
    dispatch(loadData(currentCenter))
  }
}

function setCenterDetail(centerDetail: any) {
  function loadData(data: any) {
    return { type: appConstants.CENTER_DETAIL, data }
  }
  return (dispatch: any) => {
    dispatch(loadData(centerDetail))
  }
}

function setReadOnly(data: any) {
  function loadData(data: any) {
    return { type: appConstants.READ_ONLY, data }
  }
  return (dispatch: any) => {
    dispatch(loadData(data))
  }
}

function setNotifications(data: any) {
  function loadData(data: any) {
    return { type: appConstants.NOTIFICATION, data }
  }
  return (dispatch: any) => {
    dispatch(loadData(data))
  }
}

function reset() {
  return (dispatch: any) => {
    dispatch({
      type: appConstants.RESET,
    })
  }
}

export const userAction = {
  setUser,
  setUserRole,
  setCenterDetail,
  setReadOnly,
  setUserCurrentCenter,
  setNotifications,
  reset
}

export default userAction
